export enum Color {
  black = "#000000",
  white = "#ffffff",
  success = "#198754",
  warning = "#fd7e14",
  danger = "#dc3545",
  bodyTertiary = "#f8f9fa",
  bodyTertiaryDark = "#2b3035",
}